import { render, staticRenderFns } from "./MixFodderDialog.vue?vue&type=template&id=20f9434e&lang=pug&"
import script from "./MixFodderDialog.vue?vue&type=script&lang=js&"
export * from "./MixFodderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports